<template>
  <v-row>
    <v-col cols="12">
      <div class="credit-card" />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { onMounted, type Ref, ref } from "vue";
import Card, { type CardFormSelectors } from "card";

interface Props {
  form?: string;
  formSelectors?: CardFormSelectors;
}

const props = defineProps<Props>();

const card: Ref<Card | undefined> = ref(undefined);

onMounted(() => {
  card.value = new Card({
    form: props.form,
    formSelectors: props.formSelectors,
    container: "div.credit-card",
    formatting: true,
    width: 300,
    placeholders: {
      number: "•••• •••• •••• ••••",
      name: "Nome Completo",
      expiry: "••/••",
      cvc: "•••",
    },
  });
});

defineOptions({
  name: "TCreditCard",
});
</script>
